import { forwardRef, createElement } from 'react';

function IconChevronLeftSolid(props, svgRef) {
  return createElement("svg", Object.assign({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 6.207a.5.5 0 00-.854-.353l-5.792 5.792a.5.5 0 000 .708l5.792 5.792a.5.5 0 00.854-.353V6.207z",
    fill: "currentColor"
  }));
}

var ChevronLeftSolid = /*#__PURE__*/forwardRef(IconChevronLeftSolid);

export default ChevronLeftSolid;
//# sourceMappingURL=ChevronLeftSolid.js.map
